import { filterXSS, IFilterXSSOptions } from 'xss';

const whiteList = {
  none: [],
  paragraph: ['class', 'rel', 'style'],
  block: ['class', 'rel', 'style'],
  span: ['style'],
  link: ['href', 'target'],
  image: ['src', 'alt', 'style', 'data-width', 'data-height']
};

const options: IFilterXSSOptions = {
  whiteList: {
    a: whiteList.link,
    b: whiteList.none,
    br: whiteList.none,
    del: whiteList.none,
    div: whiteList.block,
    em: whiteList.none,
    h1: whiteList.paragraph,
    h2: whiteList.paragraph,
    h3: whiteList.paragraph,
    h4: whiteList.paragraph,
    h5: whiteList.paragraph,
    h6: whiteList.paragraph,
    i: whiteList.none,
    img: whiteList.image,
    li: whiteList.block,
    ol: whiteList.block,
    p: whiteList.paragraph,
    s: whiteList.none,
    span: whiteList.span,
    strong: whiteList.none,
    table: whiteList.block,
    tbody: whiteList.block,
    td: whiteList.block,
    tfoot: whiteList.block,
    th: whiteList.block,
    thead: whiteList.block,
    tr: whiteList.block,
    u: whiteList.none,
    ul: whiteList.block,
    hr: whiteList.block
  }
};

/**
 * To filter source to prevent XSS attacks.
 * And also filter the unacceptable attributes on HTMLElement.
 */
export function xss(text: string) {
  return filterXSS(text, options);
}
